// Polis, l'onglet Sonar : parler aux électeurs d'une vague (11 octobre 2026).
export default {
  chargement: 'Les électeurs de la vague se lisent…',
  erreur: 'Les électeurs de cette vague n’ont pas pu se lire.',
  reessayer: 'Réessayer',
  fermer: 'Fermer',
  chapeau: {
    titre: 'Parlez aux électeurs de la vague du {vague}',
    texte: 'Choisissez un groupe : ceux qui ont voté dans cette vague vous répondent, chacun avec sa voix, son vote et ses raisons.',
  },
  vague: {
    libelle: 'Vague',
    option: '{jour} · {libelle}',
    optionHeure: '{base} · {heure}',
  },
  vide: {
    titre: 'Aucune vague rendue pour l’instant',
    texte: 'Les électeurs se rencontrent dès qu’une vague a fini de voter.',
    projection: 'Aller aux projections',
  },
  sections: {
    listes: 'Les électeurs de chaque liste',
    candidats: 'Les électeurs de chaque candidat',
    indecis: 'Ceux qui hésitent encore',
    secteurs: 'Les secteurs de l’électorat',
    segments: 'Les grands groupes de l’électorat',
    legendePart: 'leur part de l’électorat',
  },
  indecis: 'Les indécis',
  titres: {
    vote: 'Les électeurs de {nom}',
    // Un persona de la fiche d'un candidat : ses électeurs dans un segment.
    persona: 'Les électeurs de {nom} · {segment}',
  },
  phrase: {
    surtout: 'surtout « {segment} » ({part})',
    age: '{n} ans d’âge médian',
    femmes: '{n} de femmes',
    votent: 'votent d’abord {premier}',
    puis: ', puis {suivant}',
    entourage: 'autour d’eux, on vote d’abord {premier}',
    indecis: 'indécis',
    abstention: 'ne votent pas',
  },
  interroger: 'Leur parler',
  reprendre: 'Reprendre la conversation',
  introuvable: 'Ce groupe n’a pas assez d’électeurs dans cette vague pour vous répondre : choisissez-en un autre.',
  aucunGroupe: 'Aucun groupe de cette vague n’a assez d’électeurs pour répondre.',
  conversations: {
    titre: 'Vos conversations avec les électeurs',
    legende: 'toutes les vagues de cette élection',
  },
  // Les questions proposées pour commencer, selon le groupe.
  questions: {
    vote1: 'Qu’est-ce qui vous a décidés ?',
    vote2: 'Qu’est-ce qui pourrait vous faire changer d’avis d’ici le vote ?',
    vote3: 'Qu’en dit-on autour de vous ?',
    indecis1: 'Entre qui hésitez-vous, et pourquoi ?',
    indecis2: 'Qu’est-ce qui vous déciderait ?',
    indecis3: 'Qu’est-ce qui vous retient encore ?',
    groupe1: 'Qu’est-ce qui compte le plus pour vous dans cette élection ?',
    groupe2: 'Pour qui votez-vous, et pourquoi ?',
    groupe3: 'Qu’est-ce qui vous inquiète en ce moment ?',
  },
}
